import { ProductDetailDataType } from '../enums/inventory-table-columns.enum';
import {
  CreateInventoryItemDto,
  InventoryItemFormValue,
} from '../interfaces/inventory-item.interface';

export function mapFormToInventoryItemDto(
  formValue: InventoryItemFormValue,
  brandId: number,
  categoryId: number,
): CreateInventoryItemDto {
  return {
    productName: formValue.productName,
    brandId,
    categoryId,
    productUpc: formValue.productUpc,
    price: Number(formValue.priceUsd),
    description: formValue.productDescription,
    productDetails: [
      {
        name: formValue.productName,
        type: ProductDetailDataType.DEFAULT,
        unit: null,
        value: formValue.productDescription,
        orderIndex: 0,
      },
    ],
  };
}
